export const ADD_VERIFICATION_PROCESS_REQUEST = 'ADD_VERIFICATION_PROCESS_REQUEST';
export const ADD_VERIFICATION_PROCESS_SUCCESS = 'ADD_VERIFICATION_PROCESS_SUCCESS';
export const ADD_VERIFICATION_PROCESS_FAIL = 'ADD_VERIFICATION_PROCESS_FAIL';
export const ADD_VERIFICATION_PROCESS_RESET = 'ADD_VERIFICATION_PROCESS_RESET';

export const GET_VERIFICATION_PROCESSES_REQUEST = 'GET_VERIFICATION_PROCESSES_REQUEST';
export const GET_VERIFICATION_PROCESSES_SUCCESS = 'GET_VERIFICATION_PROCESSES_SUCCESS';
export const GET_VERIFICATION_PROCESSES_FAIL = 'GET_VERIFICATION_PROCESSES_FAIL';
export const GET_VERIFICATION_PROCESSES_RESET = 'GET_VERIFICATION_PROCESSES_RESET';

export const UPDATE_VERIFICATION_PROCESS_REQUEST = 'UPDATE_VERIFICATION_PROCESS_REQUEST';
export const UPDATE_VERIFICATION_PROCESS_SUCCESS = 'UPDATE_VERIFICATION_PROCESS_SUCCESS';
export const UPDATE_VERIFICATION_PROCESS_FAIL = 'UPDATE_VERIFICATION_PROCESS_FAIL';
export const UPDATE_VERIFICATION_PROCESS_RESET = 'UPDATE_VERIFICATION_PROCESS_RESET';

export const DELETE_VERIFICATION_PROCESS_REQUEST = 'DELETE_VERIFICATION_PROCESS_REQUEST';
export const DELETE_VERIFICATION_PROCESS_SUCCESS = 'DELETE_VERIFICATION_PROCESS_SUCCESS';
export const DELETE_VERIFICATION_PROCESS_FAIL = 'DELETE_VERIFICATION_PROCESS_FAIL';
export const DELETE_VERIFICATION_PROCESS_RESET = 'DELETE_VERIFICATION_PROCESS_RESET';